"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const clients = [{
  id: 1,
  name: "Google",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589767/img/logo_google.png"
}, {
  id: 2,
  name: "Shopify",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589767/img/logo_shopify.png"
}, {
  id: 3,
  name: "WordPress",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589767/img/logo_wordpress.png"
}, {
  id: 4,
  name: "AWS",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589767/img/logo_aws.png"
}, {
  id: 5,
  name: "Vercel",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589767/img/logo_vercel.png"
}, {
  id: 6,
  name: "Stripe",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589767/img/logo_stripe.png"
}];
export default function TrustedByLeaders() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="109464" id="onze-partners-in-succes" className="dark bg-background py-16 md:py-24 border-y border-white/5 overflow-hidden">
      <div ref={ref} className={`container mx-auto px-4 md:px-8 max-w-7xl transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
        <h2 className="sr-only">Onze Partners in Succes</h2>
        <p className="text-center text-[0.7rem] font-bold text-muted-foreground/60 mb-10 uppercase tracking-[0.25em]">
          Gesteund door de kracht van wereldklasse technologie
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-12 gap-y-10 md:gap-x-20 lg:gap-x-24">
          {clients.map((client, i) => <img key={client.id} data-index={i} src={client.src} alt={client.name} className="h-8 md:h-10 lg:h-12 w-auto object-contain brightness-0 invert opacity-50 hover:opacity-100 transition-all duration-500 ease-in-out cursor-pointer" />)}
        </div>
      </div>
    </section>;
}